<template>
  <div class="input-box__container" :class="{ borderless: borderless }">
    <v-tooltip
      open-delay=1000
      :left="tooltipLeft"
      :right="tooltipRight"
      :top="tooltipTop"
      :bottom="tooltipBottom"
      >
      <template v-slot:activator="{ on }">
        <span v-on="on" v-if="enableToolTip">
          <v-row v-if="label !== ''" no-gutters class="form-group">
            <span v-if="label !== ''" class="item-label">{{ label }}</span>
            <span v-if="![null, undefined, ''].includes(commentLabel)" class="item-comment-label">{{ commentLabel }}</span>
            <label class="form-group-label">
              <span v-if="required && !readonly" class="mandatory">必須</span>
            </label>
          </v-row>
          <v-select
            v-bind="computedProps"
            v-on="computedListeners"
            label=""
            solo
            flat
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
          >
          <!-- 選択済みアイテム表示のカスタマイズ -->
            <template v-slot:selection="{ item }">
              <span>
                <!-- フォーカス中ならフルテキスト、アウトなら「:」以降だけを表示 -->
                {{ !revealOnFocus
                  ? item.text
                  : (
                      revealMode
                      ? item.text
                      : (item.text.includes(':') ? item.text.split(':').pop() : item.text)
                    )
                }}
              </span>
            </template>
            <template v-slot:append-outer v-if="appendOuterIcon !== null">
              <v-btn small icon color="#83bde5" class="append-outer-btn" @click="onClickAppendOuterIcon"><v-icon>{{ appendOuterIcon }}</v-icon></v-btn>
            </template>
            <!-- 読み取り状態では▼アイコンを非表示にする -->
            <template v-if="readonly" v-slot:append>
              <span/>
            </template>
          </v-select>
        </span>
        <div v-else>
          <v-row v-if="label !== ''" no-gutters class="form-group">
            <span v-if="label !== ''" class="item-label">{{ label }}</span>
            <span v-if="![null, undefined, ''].includes(commentLabel)" class="item-comment-label">{{ commentLabel }}</span>
            <label class="form-group-label">
              <span v-if="required && !readonly" class="mandatory">必須</span>
            </label>
          </v-row>
          <v-select
            v-bind="computedProps"
            v-on="computedListeners"
            label=""
            solo
            flat
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
          >
          <!-- 選択済みアイテム表示のカスタマイズ -->
            <template v-slot:selection="{ item }">
              <span>
                <!-- フォーカス中ならフルテキスト、アウトなら「:」以降だけを表示 -->
                {{ !revealOnFocus
                  ? item.text
                  : (
                      revealMode
                      ? item.text
                      : (item.text.includes(':') ? item.text.split(':').pop() : item.text)
                    )
                }}
              </span>
            </template>
            <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
              {{ label }}
              <span v-if="required" class="mandatory">必須</span>
            </template>
            <template v-slot:append-outer v-if="appendOuterIcon !== null">
              <v-btn small icon color="#83bde5" class="append-outer-btn" @click="onClickAppendOuterIcon"><v-icon>{{ appendOuterIcon }}</v-icon></v-btn>
            </template>
            <!-- 読み取り状態では▼アイコンを非表示にする -->
            <template v-if="readonly" v-slot:append>
              <span/>
            </template>
          </v-select>
        </div>
      </template>
      <span v-html="tooltipText"></span>
    </v-tooltip>
  </div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSelect } from 'vuetify/lib'

/**
 * @file DDv2用単一ドロップダウン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-select/
 * @example
  <dd-drop-down
    v-model="dropdown1value"
    :items="dropDownItems"
    :required="true"
    />
  data: () => ({
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ]
  })
 */
export default {
  name: 'DdDropDown',
  extends: VSelect,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ラベル
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * 後方アイコン
     */
    appendOuterIcon: {
      type: String,
      default: null
    },
    /**
     * 太枠
     */
    emphasis: {
      type: Boolean,
      default: false
    },
    /**
     * 枠線なし
     */
    borderless: {
      type: Boolean,
      default: false
    },
    /**
     * フォーカス時のみ値を表示する
     */
    revealOnFocus: {
      type: Boolean,
      default: false
    },
    /**
     * コメントラベル
     * ラベルの隣に小さい文字で配置
     */
    commentLabel: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    invalidMessage: '',
    revealMode: false
  }),
  created () {
  },
  mounted () {
    console.log(this.$props)
    this.invalidMessage = this.errorMessages
  },
  computed: {
    /**
     * itemsプロパティを v-select で扱える形式に変換します。
     * 文字列配列の場合、{text: 'item', value: 'item'} の形式に変換します。
     * オブジェクト配列の場合は、そのまま返します。
     */
    formattedItems () {
      if (!Array.isArray(this.items) || this.items.length === 0) {
        return this.items
      }
      // 配列の最初の要素がオブジェクトでなければ、文字列配列とみなす
      if (typeof this.items[0] !== 'object' || this.items[0] === null) {
        return this.items.map(item => ({ text: item, value: item }))
      }
      // 既にオブジェクトの配列の場合はそのまま返す
      return this.items
    },
    phtext () {
      // 下記styleで非表示にされてはいるが一応
      return !this.readonly ? '選択して下さい' : ''
    },
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        items: this.formattedItems,
        class: this.$props.class + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : '') + (this.emphasis ? ' emphasis-item' : ''),
        hideDetails: 'auto',
        dense: true,
        multiple: false,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        itemText: controls.SelectTextPropName,
        itemValue: controls.SelectValuePropName
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e),
        focusout: e => this.onFocusout(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      console.log('DdCodeTextBox.onFocus', e)
      if (this.revealOnFocus) {
        this.revealMode = true
      }
    },
    onFocusout: function (e) {
      console.log('DdCodeTextBox.onFocusout', e)
      this.revealMode = false
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    onClickAppendOuterIcon: function () {
      this.$emit('clickAppendOuterIcon')
    }
  }
}
</script>
<style scoped>
::v-deep .v-select__selections input {
  max-width: 0px;
  max-height: 0px;
}
::v-deep .v-input__append-outer {
  margin-top: 4px !important;
  margin-left: 0px !important;
}
.append-outer-btn {
  padding-left:0px !important;
  padding-right:0px !important;
  min-width: 20px !important;
}
/* solo スタイルの左右パディングをゼロに */
::v-deep .v-text-field--solo .v-input__slot {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* append-outer（▼アイコン）周りのマージン／パディングもゼロに */
::v-deep .v-input__append-outer {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
